module.exports = __webpack_public_path__ + "img/fantasybookicon.ebe97f1.webp";